import { render, staticRenderFns } from "./backTop.vue?vue&type=template&id=3ebd53aa&scoped=true&"
import script from "./backTop.vue?vue&type=script&lang=js&"
export * from "./backTop.vue?vue&type=script&lang=js&"
import style0 from "./backTop.vue?vue&type=style&index=0&id=3ebd53aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebd53aa",
  null
  
)

export default component.exports